import { Box, HStack, Image, Spinner, Text, Tooltip } from '@chakra-ui/react';

import ServiceProfileCard from 'components/v4/Cards/ServiceProfileCard/ServiceProfileCard';
import ServiceProfileCardTitle from 'components/v4/Cards/ServiceProfileCard/ServiceProfileCardTitle';

import walkthroughIds from 'pages/services/walkthroughIds';

import occLogo from 'assets/images/occ.png';
import msTeamsLogo from 'assets/images/ms_teams_logo.png';
import conferenceLogo from 'assets/images/online-conference.png';
import ServiceProfileCardImage from 'components/v4/Cards/ServiceProfileCard/ServiceProfileCardImage';
import { useSelector } from 'react-redux';

function OccService({ serviceProfile, serviceWizard, id }) {
    const { ufNewServiceProfileCard } = walkthroughIds.dashboardServices;
    const { currentPartner } = useSelector((state) => state.navigationLists);
    return (
        <ServiceProfileCard
            key={id}
            pointerEvents={serviceWizard.isCreatingService ? 'none' : 'auto'}
            onClick={(e) => {
                serviceWizard.createService(serviceProfile);
            }}
            data-walkthroughid={`${ufNewServiceProfileCard}/${id}`}>
            {serviceWizard.isCreatingService && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'absolute',
                        height: '100%',
                        width: '100%',
                        left: '0',
                        top: '0',
                        background: 'white',
                        opacity: '0.7',
                    }}>
                    {serviceWizard.selectedServiceProfile.serviceType ===
                        'OperatorConnectConferencing' && (
                        <Spinner
                            thickness="4px"
                            emptyColor="gray.200"
                            color="brand.500"
                            size="xl"
                        />
                    )}
                </Box>
            )}
            <ServiceProfileCardImage src={occLogo} />
            <ServiceProfileCardTitle>
                Operator Connect Conferencing
            </ServiceProfileCardTitle>
            <Text>
                Enable Operator Connect Conferencing connectivity. This requires
                a valid Operator Connect service to be deployed.
            </Text>
            {currentPartner == '100d5296-0c38-4192-1c43-08dbec03eb47' && (
                <HStack mt={'auto'}>
                    <Tooltip label="Microsoft">
                        <Image boxSize={'5'} src={msTeamsLogo} />
                    </Tooltip>
                    <Tooltip label="Audio Conferencing">
                        <Image boxSize={'5'} src={conferenceLogo} />
                    </Tooltip>
                </HStack>
            )}
        </ServiceProfileCard>
    );
}

export default OccService;
